module.exports = __webpack_public_path__ + "static/language-selector-mobile-screen-41c9578bfce6c9dd54e87cab1a9e040a.png";